import type { FocusEvent } from 'react';

/** briX shared UI tokens — slate brand (matches sidebar & sign-in) */

/** QuickBooks-style: select all text when a numeric field receives focus. */
export const selectInputOnFocus = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  e.target.select();
};

export const brand = {
  primary: 'bg-slate-800 hover:bg-slate-700 text-white focus:ring-slate-800',
  primarySolid: 'bg-slate-800',
  primaryHover: 'hover:bg-slate-700',
  ring: 'focus:ring-slate-800',
  borderFocus: 'focus:border-slate-600',
  text: 'text-slate-800',
  textMuted: 'text-slate-600',
  soft: 'bg-slate-50',
  softBorder: 'border-slate-200',
} as const;

export const btnPrimary =
  'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg text-white bg-slate-800 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const btnPrimaryMd =
  'inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium rounded-lg text-white bg-slate-800 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const btnPrimaryLg =
  'inline-flex items-center justify-center px-6 py-3 text-base font-semibold rounded-lg text-white bg-slate-800 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const btnSecondary =
  'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-800 transition-colors';

export const btnDanger =
  'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors';

export const filterTabActive =
  'px-4 py-2 text-sm font-medium rounded-lg bg-slate-800 text-white shadow-sm transition-colors';

export const filterTabInactive =
  'px-4 py-2 text-sm font-medium rounded-lg bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 transition-colors';

export const inputFocus =
  'focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-600';
